import router from '@/router';
import store from '@/store';
import TagsGroupsService from '@Tags/services/tagGroups.service';
import Vue from 'vue';
import { FACILITY_REQUEST } from '@/utils/http/RequestRegistry';

export const TAGS_GROUPS = {
  namespaced: true,
  state: {
    selectedGroup: null,
    tagGroups: [],
    tagsGroupsCounts: [],
    tagsGroupsCountsLoading: false,
    openedTreeNodes: [],
  },
  getters: {
    GET_SELECTED_GROUP(state) {
      return state.selectedGroup;
    },
    GET_TAGS_GROUPS_COUNTS(state) {
      return state.tagsGroupsCounts;
    },
    GET_TAGS_GROUPS_COUNTS_LOADING(state) {
      return state.tagsGroupsCountsLoading;
    },
    GET_OPENED_TREE_NODES(state) {
      return state.openedTreeNodes;
    },
    GET_TAG_GROUPS(state) {
      return state.tagGroups;
    }
  },
  mutations: {
    SET_SELECTED_GROUP(state, val) {
      state.selectedGroup = val;
    },
    SET_TAGS_GROUPS_COUNTS(state, val) {
      state.tagsGroupsCounts = val;
    },
    SET_TAGS_GROUPS_COUNTS_LOADING(state, val) {
      state.tagsGroupsCountsLoading = val;
    },
    SET_OPENED_TREE_NODES(state, val) {
      state.openedTreeNodes = val;
    },
    SET_TAG_GROUPS(state, val) {
      state.tagGroups = val;
    }
  },
  actions: {
    async GET_TAGS_GROUPS_COUNTS({ commit }) {
      commit("SET_TAGS_GROUPS_COUNTS_LOADING", true);

      let facilityId = store.getters["FACILITY/GET_FACILITY"]?.id;

      TagsGroupsService.getCounts({ facilityId }).then(({ data }) => {
        commit("SET_TAGS_GROUPS_COUNTS", data);
      }).catch(() => {
        Vue.prototype.$dialog.notify.error("Failed to fetch tags types counts");
      }).finally(() => {
        commit("SET_TAGS_GROUPS_COUNTS_LOADING", false);
      });
    },
    ONE_STEP_BACK({ commit, getters }) {
      let previousTags = store.getters['GET_PREVIOUS_TAGS'];
      let editElement = store.getters['GET_EDITING_TAG'];
      let isReadOnly = store.getters['GET_IS_TAG_READ_ONLY'];
      let selectedGroup = getters['GET_SELECTED_GROUP'];

      if (!previousTags.length && !editElement && !selectedGroup) {
        store.dispatch('closeLeftTab');
        return;
      }

      if (previousTags.length) {
        store.dispatch('POP_TAG_FROM_PREVIOUS_TAGS');
      } else if (editElement) {
        if (isReadOnly) {
          store.dispatch('CLEAR_EDIT_TAG_TAB');
        } else {
          Vue.prototype.$dialog.confirm({
            text: 'Do you want to discard changes?',
            title: 'Save Changes',
            actions: {
              false: {
                text: 'Yes',
                color: 'error',
                handle: () => {
                  store.commit('SET_IS_TAG_READ_ONLY', true);
                },
              },
              true: {
                text: 'No',
                color: 'primary'
              },
            },
          });
        }
      } else {
        commit('SET_SELECTED_GROUP', null);
      }
    },
    async GET_TAG_GROUPS({ commit }) {
      return new Promise((resolve, reject) => {
        let facilityId = router.currentRoute.params.id;

        TagsGroupsService.get({ facilityId }, FACILITY_REQUEST).then(({ data }) => {
          commit('SET_TAG_GROUPS', data);
          resolve(data);
        }).catch(() => {
          Vue.prototype.$dialog.notify.error('Failed to fetch tag groups');
          reject();
        });
      });
    },
    async ADD_TAG_GROUP({ state }, data) {
      return new Promise((resolve, reject) => {
        TagsGroupsService.add(data).then(({ data }) => {
          Vue.prototype.$dialog.notify.success('Tag group added successfully');
          state.tagGroups.push(data);
          resolve(data);
        }).catch(() => {
          Vue.prototype.$dialog.notify.error('Failed to add tag group');
          reject();
        });
      });
    },
    async DELETE_TAG_GROUP({ state }, id) {
      return new Promise((resolve, reject) => {
        TagsGroupsService.delete(id).then(() => {
          Vue.prototype.$dialog.notify.success('Tag group deleted successfully');
          state.tagGroups = state.tagGroups.filter(group => group.id !== id);
          resolve();
        }).catch(() => {
          Vue.prototype.$dialog.notify.error('Failed to delete tag group');
          reject();
        });
      });
    }
  },
}